import { MooringPassingMark } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const MOORING_APPROACHING_DATA_TAG = 'MooringApproaching';
const MOORING_SAILING_OFF_DATA_TAG = 'MooringSailingOff';
class MooringPassingMarkParser extends OldRecordsParser {
    constructor(protocolTypeId, dataTag, app) {
        super(protocolTypeId, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_PASSING_MARK, dataTag, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            mark: 'mark',
            side: 'side',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new MooringPassingMark(props.port, props.mark, props.side, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
export class MooringApproachingParser extends MooringPassingMarkParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_APPROACHING, MOORING_APPROACHING_DATA_TAG, app);
    }
}
export class MooringSailingOffParser extends MooringPassingMarkParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_SAILING_OFF, MOORING_SAILING_OFF_DATA_TAG, app);
    }
}
//# sourceMappingURL=MooringPassingMarkParser.js.map